export { default as useEventCallback } from './useEventCallback';
//# sourceMappingURL=index.js.map